// src/api/creditoCuota.js - API para manejo de créditos y cuotas
import { apiFetch } from './index.js';

/**
 * Obtener todas las cuotas de crédito
 * @returns {Promise} Lista de cuotas
 */
export const obtenerCuotasCredito = async () => {
  try {
    console.log('📋 Obteniendo todas las cuotas de crédito...');
    
    const response = await apiFetch('/api/CreditoCuota');
    
    const data = Array.isArray(response) ? response : (response.data || []);
    const cuotasNormalizadas = data.map(cuota => ({
      idCreditoCuota: cuota.idCuota || cuota.idCreditoCuota,
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: cuota.numeroCuota,
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: cuota.montoUsd || 0,
      saldoUsd: cuota.saldoUsd || 0,
      montoBs: cuota.montoBs || 0,
      saldoBs: cuota.saldoBs || 0,
      interesMoraUsd: cuota.interesMoraUsd || 0,
      interesMoraBs: cuota.interesMoraBs || 0,
      estado: cuota.estado,
      fechaPago: cuota.fechaPago,
      observaciones: cuota.observaciones,
      fecha_creacion: cuota.fecha_creacion || cuota.fechaCreacion
    }));
    
    return {
      success: true,
      data: cuotasNormalizadas,
      count: cuotasNormalizadas.length,
      message: 'Cuotas obtenidas exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error obteniendo cuotas:', error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener una cuota por ID
 * @param {number} id - ID de la cuota
 * @returns {Promise} Datos de la cuota
 */
export const obtenerCuotaPorId = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de cuota es requerido');
    }
    
    console.log(`🔍 Obteniendo cuota ID: ${id}`);
    
    const response = await apiFetch(`/api/CreditoCuota/${id}`);
    
    const data = response.data || response;
    
    return {
      success: true,
      data: {
        idCreditoCuota: data.idCuota || data.idCreditoCuota,
        idVenta: data.idVenta,
        codigoTipoCredito: data.codigoTipoCredito,
        numeroCuota: data.numeroCuota,
        fechaVencimiento: data.fechaVencimiento,
        montoUsd: data.montoUsd || 0,
        saldoUsd: data.saldoUsd || 0,
        montoBs: data.montoBs || 0,
        saldoBs: data.saldoBs || 0,
        interesMoraUsd: data.interesMoraUsd || 0,
        interesMoraBs: data.interesMoraBs || 0,
        estado: data.estado,
        fechaPago: data.fechaPago,
        observaciones: data.observaciones
      },
      message: response.message || 'Cuota obtenida exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo cuota ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener cuotas pendientes
 * @returns {Promise} Lista de cuotas pendientes
 */
export const obtenerCuotasPendientes = async () => {
  try {
    console.log('📋 Obteniendo cuotas pendientes...');
    
    const response = await apiFetch('/api/CreditoCuota/pendientes');
    
    const data = Array.isArray(response) ? response : (response.data || []);
    const cuotasNormalizadas = data.map(cuota => ({
      idCreditoCuota: cuota.idCreditoCuota,
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: cuota.numeroCuota,
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: cuota.montoUsd || 0,
      saldoUsd: cuota.saldoUsd || 0,
      montoBs: cuota.montoBs || 0,
      saldoBs: cuota.saldoBs || 0,
      interesMoraUsd: cuota.interesMoraUsd || 0,
      interesMoraBs: cuota.interesMoraBs || 0,
      estado: cuota.estado,
      fechaPago: cuota.fechaPago,
      observaciones: cuota.observaciones
    }));
    
    return {
      success: true,
      data: cuotasNormalizadas,
      count: cuotasNormalizadas.length,
      message: 'Cuotas pendientes obtenidas exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error obteniendo cuotas pendientes:', error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener cuotas vencidas
 * @returns {Promise} Lista de cuotas vencidas
 */
export const obtenerCuotasVencidas = async () => {
  try {
    console.log('📋 Obteniendo cuotas vencidas...');
    
    const response = await apiFetch('/api/CreditoCuota/vencidas');
    
    const data = Array.isArray(response) ? response : (response.data || []);
    const cuotasNormalizadas = data.map(cuota => ({
      idCreditoCuota: cuota.idCreditoCuota,
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: cuota.numeroCuota,
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: cuota.montoUsd || 0,
      saldoUsd: cuota.saldoUsd || 0,
      montoBs: cuota.montoBs || 0,
      saldoBs: cuota.saldoBs || 0,
      interesMoraUsd: cuota.interesMoraUsd || 0,
      interesMoraBs: cuota.interesMoraBs || 0,
      estado: cuota.estado,
      fechaPago: cuota.fechaPago,
      observaciones: cuota.observaciones,
      diasVencidos: cuota.diasVencidos || 0,
      montoTotalVencido: cuota.montoTotalVencido || 0
    }));
    
    return {
      success: true,
      data: cuotasNormalizadas,
      count: cuotasNormalizadas.length,
      message: 'Cuotas vencidas obtenidas exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error obteniendo cuotas vencidas:', error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener cuotas por estado
 * @param {string} estado - Estado de la cuota (pendiente, pagada, vencida, anulada)
 * @returns {Promise} Lista de cuotas con el estado especificado
 */
export const obtenerCuotasPorEstado = async (estado) => {
  try {
    if (!estado) {
      throw new Error('Estado es requerido');
    }
    
    console.log(`📋 Obteniendo cuotas con estado: ${estado}`);
    
    const response = await apiFetch(`/api/CreditoCuota/estado/${encodeURIComponent(estado)}`);
    
    const data = Array.isArray(response) ? response : (response.data || []);
    const cuotasNormalizadas = data.map(cuota => ({
      idCreditoCuota: cuota.idCreditoCuota,
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: cuota.numeroCuota,
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: cuota.montoUsd || 0,
      saldoUsd: cuota.saldoUsd || 0,
      montoBs: cuota.montoBs || 0,
      saldoBs: cuota.saldoBs || 0,
      interesMoraUsd: cuota.interesMoraUsd || 0,
      interesMoraBs: cuota.interesMoraBs || 0,
      estado: cuota.estado,
      fechaPago: cuota.fechaPago,
      observaciones: cuota.observaciones
    }));
    
    return {
      success: true,
      data: cuotasNormalizadas,
      count: cuotasNormalizadas.length,
      message: `Cuotas con estado ${estado} obtenidas exitosamente`
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo cuotas por estado ${estado}:`, error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener cuotas por ID de venta
 * @param {number} idVenta - ID de la venta
 * @returns {Promise} Lista de cuotas de la venta
 */
export const obtenerCuotasPorVenta = async (idVenta) => {
  try {
    if (!idVenta) {
      throw new Error('ID de venta es requerido');
    }
    
    console.log(`📋 Obteniendo cuotas de venta ID: ${idVenta}`);
    
    const response = await apiFetch(`/api/CreditoCuota/venta/${idVenta}`);
    
    const data = Array.isArray(response) ? response : (response.data || []);
    const cuotasNormalizadas = data.map(cuota => ({
      idCreditoCuota: cuota.idCreditoCuota,
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: cuota.numeroCuota,
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: cuota.montoUsd || 0,
      saldoUsd: cuota.saldoUsd || 0,
      montoBs: cuota.montoBs || 0,
      saldoBs: cuota.saldoBs || 0,
      interesMoraUsd: cuota.interesMoraUsd || 0,
      interesMoraBs: cuota.interesMoraBs || 0,
      estado: cuota.estado,
      fechaPago: cuota.fechaPago,
      observaciones: cuota.observaciones
    }));
    
    return {
      success: true,
      data: cuotasNormalizadas,
      count: cuotasNormalizadas.length,
      message: 'Cuotas de venta obtenidas exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo cuotas de venta ${idVenta}:`, error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener resumen de cuotas por venta
 * @param {number} idVenta - ID de la venta
 * @returns {Promise} Resumen de cuotas
 */
export const obtenerResumenCuotasVenta = async (idVenta) => {
  try {
    if (!idVenta) {
      throw new Error('ID de venta es requerido');
    }
    
    console.log(`📊 Obteniendo resumen de cuotas para venta ID: ${idVenta}`);
    
    const response = await apiFetch(`/api/CreditoCuota/venta/${idVenta}/resumen`);
    
    return {
      success: true,
      data: response.data || response,
      message: response.message || 'Resumen obtenido exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo resumen de cuotas ${idVenta}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener cuotas por rango de vencimiento
 * @param {string} desde - Fecha inicial (YYYY-MM-DD)
 * @param {string} hasta - Fecha final (YYYY-MM-DD)
 * @returns {Promise} Lista de cuotas en el rango
 */
export const obtenerCuotasPorVencimiento = async (desde, hasta) => {
  try {
    if (!desde || !hasta) {
      throw new Error('Fechas desde y hasta son requeridas');
    }
    
    console.log(`📅 Obteniendo cuotas con vencimiento entre ${desde} y ${hasta}`);
    
    const response = await apiFetch(`/api/CreditoCuota/vencimiento/${desde}/${hasta}`);
    
    const data = Array.isArray(response) ? response : (response.data || []);
    const cuotasNormalizadas = data.map(cuota => ({
      idCreditoCuota: cuota.idCreditoCuota,
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: cuota.numeroCuota,
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: cuota.montoUsd || 0,
      saldoUsd: cuota.saldoUsd || 0,
      montoBs: cuota.montoBs || 0,
      saldoBs: cuota.saldoBs || 0,
      interesMoraUsd: cuota.interesMoraUsd || 0,
      interesMoraBs: cuota.interesMoraBs || 0,
      estado: cuota.estado,
      fechaPago: cuota.fechaPago,
      observaciones: cuota.observaciones
    }));
    
    return {
      success: true,
      data: cuotasNormalizadas,
      count: cuotasNormalizadas.length,
      message: 'Cuotas en rango de vencimiento obtenidas exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error obteniendo cuotas por vencimiento:', error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener cuota con relaciones
 * @param {number} id - ID de la cuota
 * @returns {Promise} Datos de la cuota con relaciones
 */
export const obtenerCuotaConRelaciones = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de cuota es requerido');
    }
    
    console.log(`🔍 Obteniendo cuota con relaciones ID: ${id}`);
    
    const response = await apiFetch(`/api/CreditoCuota/${id}/conRelaciones`);
    
    return {
      success: true,
      data: response.data || response,
      message: response.message || 'Cuota obtenida exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo cuota con relaciones ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Buscar cuotas por término
 * @param {string} termino - Término de búsqueda
 * @returns {Promise} Lista de cuotas que coinciden
 */
export const buscarCuotasAPI = async (termino) => {
  try {
    if (!termino || termino.trim() === '') {
      throw new Error('Término de búsqueda es requerido');
    }
    
    console.log(`🔎 Buscando cuotas: "${termino}"`);
    
    const response = await apiFetch('/api/CreditoCuota/search', {
      method: 'POST',
      body: JSON.stringify({ termino: termino.trim() })
    });
    
    const data = response.data || response;
    
    return {
      success: true,
      data: Array.isArray(data) ? data : [],
      count: Array.isArray(data) ? data.length : 0,
      message: response.message || 'Búsqueda completada'
    };
    
  } catch (error) {
    console.error(`❌ Error buscando cuotas "${termino}":`, error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Verificar si una cuota existe por ID
 * @param {number} id - ID de la cuota
 * @returns {Promise} Resultado de la verificación
 */
export const verificarCuotaExistente = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de cuota es requerido');
    }
    
    console.log(`🔎 Verificando cuota ID: ${id}`);
    
    const response = await apiFetch(`/api/CreditoCuota/${id}/exists`);
    
    return {
      success: true,
      existe: response.exists || response.data?.exists || false,
      message: response.message || (response.exists ? 'La cuota existe' : 'La cuota no existe')
    };
    
  } catch (error) {
    console.error(`❌ Error verificando cuota ${id}:`, error);
    return {
      success: false,
      error: error.message,
      existe: false
    };
  }
};

/**
 * Crear una nueva cuota de crédito
 * @param {Object} cuotaData - Datos de la cuota
 * @returns {Promise} Cuota creada
 */
export const crearCuotaCredito = async (cuotaData) => {
  try {
    // Validar datos requeridos
    if (!cuotaData.idVenta) {
      throw new Error('ID de venta es requerido');
    }
    
    if (!cuotaData.codigoTipoCredito) {
      throw new Error('Código de tipo de crédito es requerido');
    }
    
    if (!cuotaData.numeroCuota || cuotaData.numeroCuota <= 0) {
      throw new Error('Número de cuota válido es requerido');
    }
    
    if (!cuotaData.fechaVencimiento) {
      throw new Error('Fecha de vencimiento es requerida');
    }
    
    if (!cuotaData.montoUsd && !cuotaData.montoBs) {
      throw new Error('Se requiere al menos un monto (USD o Bs)');
    }
    
    console.log('➕ Creando nueva cuota de crédito:', cuotaData);
    
    const response = await apiFetch('/api/CreditoCuota', {
      method: 'POST',
      body: JSON.stringify({
        idVenta: cuotaData.idVenta,
        codigoTipoCredito: cuotaData.codigoTipoCredito,
        numeroCuota: parseInt(cuotaData.numeroCuota),
        fechaVencimiento: cuotaData.fechaVencimiento,
        montoUsd: parseFloat(cuotaData.montoUsd) || 0,
        saldoUsd: parseFloat(cuotaData.saldoUsd) || parseFloat(cuotaData.montoUsd) || 0,
        montoBs: parseFloat(cuotaData.montoBs) || 0,
        saldoBs: parseFloat(cuotaData.saldoBs) || parseFloat(cuotaData.montoBs) || 0,
        interesMoraUsd: parseFloat(cuotaData.interesMoraUsd) || 0,
        interesMoraBs: parseFloat(cuotaData.interesMoraBs) || 0,
        estado: cuotaData.estado || 'pendiente',
        fechaPago: cuotaData.fechaPago || null,
        observaciones: cuotaData.observaciones || null
      })
    });
    
    return {
      success: true,
      data: response.data || response,
      message: response.message || 'Cuota creada exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error creando cuota:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Crear múltiples cuotas de crédito
 * @param {Array} cuotasData - Lista de cuotas a crear
 * @returns {Promise} Resultado de la creación múltiple
 */
export const crearMultiplesCuotas = async (cuotasData) => {
  try {
    if (!cuotasData || cuotasData.length === 0) {
      throw new Error('Se requiere al menos una cuota para crear');
    }
    
    console.log(`➕ Creando ${cuotasData.length} cuotas de crédito...`);
    
    const cuotasFormateadas = cuotasData.map(cuota => ({
      idVenta: cuota.idVenta,
      codigoTipoCredito: cuota.codigoTipoCredito,
      numeroCuota: parseInt(cuota.numeroCuota),
      fechaVencimiento: cuota.fechaVencimiento,
      montoUsd: parseFloat(cuota.montoUsd) || 0,
      saldoUsd: parseFloat(cuota.saldoUsd) || parseFloat(cuota.montoUsd) || 0,
      montoBs: parseFloat(cuota.montoBs) || 0,
      saldoBs: parseFloat(cuota.saldoBs) || parseFloat(cuota.montoBs) || 0,
      interesMoraUsd: parseFloat(cuota.interesMoraUsd) || 0,
      interesMoraBs: parseFloat(cuota.interesMoraBs) || 0,
      estado: cuota.estado || 'pendiente',
      fechaPago: cuota.fechaPago || null,
      observaciones: cuota.observaciones || null
    }));
    
    const response = await apiFetch('/api/CreditoCuota/multiple', {
      method: 'POST',
      body: JSON.stringify(cuotasFormateadas)
    });
    
    return {
      success: true,
      data: response.data || response,
      count: cuotasData.length,
      message: response.message || `${cuotasData.length} cuotas creadas exitosamente`
    };
    
  } catch (error) {
    console.error('❌ Error creando múltiples cuotas:', error);
    return {
      success: false,
      error: error.message,
      data: null,
      count: 0
    };
  }
};

/**
 * Actualizar una cuota existente
 * @param {number} id - ID de la cuota
 * @param {Object} cuotaData - Datos a actualizar
 * @returns {Promise} Cuota actualizada
 */
export const actualizarCuotaCredito = async (id, cuotaData) => {
  try {
    if (!id) {
      throw new Error('ID de cuota es requerido');
    }
    
    console.log(`✏️ Actualizando cuota ID: ${id}`, cuotaData);
    
    const payload = {
      idCreditoCuota: parseInt(id),
      idVenta: cuotaData.idVenta,
      codigoTipoCredito: cuotaData.codigoTipoCredito,
      numeroCuota: parseInt(cuotaData.numeroCuota),
      fechaVencimiento: cuotaData.fechaVencimiento,
      montoUsd: parseFloat(cuotaData.montoUsd) || 0,
      saldoUsd: parseFloat(cuotaData.saldoUsd) || 0,
      montoBs: parseFloat(cuotaData.montoBs) || 0,
      saldoBs: parseFloat(cuotaData.saldoBs) || 0,
      interesMoraUsd: parseFloat(cuotaData.interesMoraUsd) || 0,
      interesMoraBs: parseFloat(cuotaData.interesMoraBs) || 0,
      estado: cuotaData.estado,
      fechaPago: cuotaData.fechaPago || null,
      observaciones: cuotaData.observaciones || null
    };
    
    console.log('📦 Payload enviado a la API:', payload);
    
    const response = await apiFetch(`/api/CreditoCuota/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
    
    return {
      success: true,
      data: response.data || response,
      message: response.message || 'Cuota actualizada exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error actualizando cuota ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Pagar una cuota
 * @param {number} id - ID de la cuota
 * @param {Object} pagoData - Datos del pago
 * @returns {Promise} Resultado del pago
 */
export const pagarCuota = async (id, pagoData) => {
  try {
    if (!id) {
      throw new Error('ID de cuota es requerido');
    }
    
    console.log(`💰 Pagando cuota ID: ${id}`, pagoData);
    
    const response = await apiFetch('/api/CreditoCuota/pagar', {
      method: 'POST',
      body: JSON.stringify({
        idCreditoCuota: parseInt(id),
        montoUsdPagado: parseFloat(pagoData.montoUsdPagado) || 0,
        montoBsPagado: parseFloat(pagoData.montoBsPagado) || 0,
        fechaPago: pagoData.fechaPago || new Date().toISOString(),
        numeroRecibo: pagoData.numeroRecibo || null,
        observaciones: pagoData.observaciones || null
      })
    });
    
    return {
      success: true,
      data: response.data || response,
      message: response.message || 'Cuota pagada exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error pagando cuota ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Eliminar una cuota
 * @param {number} id - ID de la cuota a eliminar
 * @returns {Promise} Resultado de la eliminación
 */
export const eliminarCuotaCredito = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de cuota es requerido');
    }
    
    console.log(`🗑️ Eliminando cuota ID: ${id}`);
    
    const response = await apiFetch(`/api/CreditoCuota/${id}`, {
      method: 'DELETE'
    });
    
    return {
      success: true,
      data: response.data || response,
      message: response.message || 'Cuota eliminada exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error eliminando cuota ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

// ==================== FUNCIONES AUXILIARES (CLIENTE-SIDE) ====================

/**
 * Buscar cuotas por término (cliente-side)
 * @param {Array} cuotas - Lista de cuotas
 * @param {string} termino - Término de búsqueda
 * @returns {Array} Cuotas filtradas
 */
export const buscarCuotasLocal = (cuotas, termino) => {
  if (!termino || termino.trim() === '') {
    return cuotas;
  }
  
  const terminoLower = termino.toLowerCase();
  return cuotas.filter(cuota => 
    cuota.idVenta?.toString().includes(terminoLower) ||
    cuota.codigoTipoCredito?.toLowerCase().includes(terminoLower) ||
    cuota.numeroCuota?.toString().includes(terminoLower) ||
    cuota.estado?.toLowerCase().includes(terminoLower) ||
    cuota.observaciones?.toLowerCase().includes(terminoLower)
  );
};

/**
 * Filtrar cuotas por estado (cliente-side)
 * @param {Array} cuotas - Lista de cuotas
 * @param {string} estado - Estado a filtrar
 * @returns {Array} Cuotas filtradas
 */
export const filtrarCuotasPorEstadoLocal = (cuotas, estado) => {
  if (!estado || estado === 'all') return cuotas;
  return cuotas.filter(c => c.estado?.toLowerCase() === estado.toLowerCase());
};

/**
 * Filtrar cuotas por rango de fechas (cliente-side)
 * @param {Array} cuotas - Lista de cuotas
 * @param {Date} fechaInicio - Fecha inicial
 * @param {Date} fechaFin - Fecha final
 * @returns {Array} Cuotas filtradas
 */
export const filtrarCuotasPorFechaLocal = (cuotas, fechaInicio, fechaFin) => {
  if (!fechaInicio && !fechaFin) return cuotas;
  
  return cuotas.filter(cuota => {
    const fechaVencimiento = new Date(cuota.fechaVencimiento);
    if (fechaInicio && fechaFin) {
      return fechaVencimiento >= fechaInicio && fechaVencimiento <= fechaFin;
    } else if (fechaInicio) {
      return fechaVencimiento >= fechaInicio;
    } else if (fechaFin) {
      return fechaVencimiento <= fechaFin;
    }
    return true;
  });
};

/**
 * Obtener estadísticas de cuotas
 * @param {Array} cuotas - Lista de cuotas
 * @returns {Object} Estadísticas
 */
export const obtenerEstadisticasCuotas = (cuotas) => {
  // Totales
  const totalMontoUsd = cuotas.reduce((sum, c) => sum + (c.montoUsd || 0), 0);
  const totalMontoBs = cuotas.reduce((sum, c) => sum + (c.montoBs || 0), 0);
  const totalSaldoUsd = cuotas.reduce((sum, c) => sum + (c.saldoUsd || 0), 0);
  const totalSaldoBs = cuotas.reduce((sum, c) => sum + (c.saldoBs || 0), 0);
  const totalPagadoUsd = totalMontoUsd - totalSaldoUsd;
  const totalPagadoBs = totalMontoBs - totalSaldoBs;
  
  // Porcentaje pagado
  const porcentajePagadoUsd = totalMontoUsd > 0 ? (totalPagadoUsd / totalMontoUsd) * 100 : 0;
  const porcentajePagadoBs = totalMontoBs > 0 ? (totalPagadoBs / totalMontoBs) * 100 : 0;
  
  // Estados
  const pendientes = cuotas.filter(c => c.estado?.toLowerCase() === 'pendiente').length;
  const pagadas = cuotas.filter(c => c.estado?.toLowerCase() === 'pagada').length;
  const vencidas = cuotas.filter(c => c.estado?.toLowerCase() === 'vencida').length;
  const anuladas = cuotas.filter(c => c.estado?.toLowerCase() === 'anulada').length;
  
  // Intereses de mora
  const totalInteresMoraUsd = cuotas.reduce((sum, c) => sum + (c.interesMoraUsd || 0), 0);
  const totalInteresMoraBs = cuotas.reduce((sum, c) => sum + (c.interesMoraBs || 0), 0);
  
  // Cuotas por tipo de crédito
  const cuotasPorTipo = {};
  cuotas.forEach(cuota => {
    const tipo = cuota.codigoTipoCredito || 'desconocido';
    cuotasPorTipo[tipo] = (cuotasPorTipo[tipo] || 0) + 1;
  });
  
  // Montos por tipo de crédito
  const montosPorTipo = {};
  cuotas.forEach(cuota => {
    const tipo = cuota.codigoTipoCredito || 'desconocido';
    if (!montosPorTipo[tipo]) {
      montosPorTipo[tipo] = { montoUsd: 0, montoBs: 0, saldoUsd: 0, saldoBs: 0 };
    }
    montosPorTipo[tipo].montoUsd += cuota.montoUsd || 0;
    montosPorTipo[tipo].montoBs += cuota.montoBs || 0;
    montosPorTipo[tipo].saldoUsd += cuota.saldoUsd || 0;
    montosPorTipo[tipo].saldoBs += cuota.saldoBs || 0;
  });
  
  // Cuotas por vencer (próximos 30 días)
  const hoy = new Date();
  const proximos30Dias = new Date();
  proximos30Dias.setDate(proximos30Dias.getDate() + 30);
  
  const porVencer = cuotas.filter(c => {
    try {
      const fechaVen = new Date(c.fechaVencimiento);
      return c.estado?.toLowerCase() === 'pendiente' && 
             fechaVen >= hoy && 
             fechaVen <= proximos30Dias;
    } catch {
      return false;
    }
  }).length;
  
  // Cuotas ya vencidas
  const hoyDate = new Date();
  hoyDate.setHours(0, 0, 0, 0);
  const vencidasReales = cuotas.filter(c => {
    try {
      const fechaVen = new Date(c.fechaVencimiento);
      return c.estado?.toLowerCase() === 'pendiente' && fechaVen < hoyDate;
    } catch {
      return false;
    }
  }).length;
  
  return {
    total: cuotas.length,
    totalMonto: { usd: totalMontoUsd, bs: totalMontoBs },
    totalSaldo: { usd: totalSaldoUsd, bs: totalSaldoBs },
    totalPagado: { usd: totalPagadoUsd, bs: totalPagadoBs },
    porcentajePagado: { usd: porcentajePagadoUsd, bs: porcentajePagadoBs },
    estados: { pendientes, pagadas, vencidas, anuladas },
    totalInteresMora: { usd: totalInteresMoraUsd, bs: totalInteresMoraBs },
    cuotasPorTipo,
    montosPorTipo,
    porVencer,
    vencidasReales,
    tasaCumplimiento: cuotas.length > 0 ? (pagadas / cuotas.length) * 100 : 0
  };
};

/**
 * Ordenar cuotas por diferentes criterios
 * @param {Array} cuotas - Lista de cuotas
 * @param {string} criterio - Criterio de ordenamiento
 * @returns {Array} Cuotas ordenadas
 */
export const ordenarCuotas = (cuotas, criterio = 'fechaVencimiento') => {
  const cuotasCopy = [...cuotas];
  
  switch (criterio) {
    case 'fechaVencimiento':
      return cuotasCopy.sort((a, b) => new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento));
    case 'fechaVencimiento_desc':
      return cuotasCopy.sort((a, b) => new Date(b.fechaVencimiento) - new Date(a.fechaVencimiento));
    case 'numeroCuota':
      return cuotasCopy.sort((a, b) => (a.numeroCuota || 0) - (b.numeroCuota || 0));
    case 'numeroCuota_desc':
      return cuotasCopy.sort((a, b) => (b.numeroCuota || 0) - (a.numeroCuota || 0));
    case 'montoUsd_desc':
      return cuotasCopy.sort((a, b) => (b.montoUsd || 0) - (a.montoUsd || 0));
    case 'montoUsd':
      return cuotasCopy.sort((a, b) => (a.montoUsd || 0) - (b.montoUsd || 0));
    case 'saldoUsd_desc':
      return cuotasCopy.sort((a, b) => (b.saldoUsd || 0) - (a.saldoUsd || 0));
    case 'estado':
      return cuotasCopy.sort((a, b) => (a.estado || '').localeCompare(b.estado || ''));
    case 'idVenta':
      return cuotasCopy.sort((a, b) => (a.idVenta || 0) - (b.idVenta || 0));
    default:
      return cuotasCopy;
  }
};

/**
 * Agrupar cuotas por venta
 * @param {Array} cuotas - Lista de cuotas
 * @returns {Object} Cuotas agrupadas por ID de venta
 */
export const agruparCuotasPorVenta = (cuotas) => {
  const grouped = {};
  cuotas.forEach(cuota => {
    const ventaId = cuota.idVenta;
    if (!grouped[ventaId]) {
      grouped[ventaId] = [];
    }
    grouped[ventaId].push(cuota);
  });
  return grouped;
};

/**
 * Calcular resumen de cuotas por venta
 * @param {Array} cuotas - Lista de cuotas de una venta
 * @returns {Object} Resumen de la venta
 */
export const calcularResumenVentaCuotas = (cuotas) => {
  const totalMontoUsd = cuotas.reduce((sum, c) => sum + (c.montoUsd || 0), 0);
  const totalMontoBs = cuotas.reduce((sum, c) => sum + (c.montoBs || 0), 0);
  const totalSaldoUsd = cuotas.reduce((sum, c) => sum + (c.saldoUsd || 0), 0);
  const totalSaldoBs = cuotas.reduce((sum, c) => sum + (c.saldoBs || 0), 0);
  const totalPagadoUsd = totalMontoUsd - totalSaldoUsd;
  const totalPagadoBs = totalMontoBs - totalSaldoBs;
  
  const cuotasPagadas = cuotas.filter(c => c.estado?.toLowerCase() === 'pagada').length;
  const cuotasPendientes = cuotas.filter(c => c.estado?.toLowerCase() === 'pendiente').length;
  const cuotasVencidas = cuotas.filter(c => c.estado?.toLowerCase() === 'vencida').length;
  
  const proximaCuota = cuotas
    .filter(c => c.estado?.toLowerCase() === 'pendiente')
    .sort((a, b) => new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento))[0];
  
  return {
    totalCuotas: cuotas.length,
    cuotasPagadas,
    cuotasPendientes,
    cuotasVencidas,
    totalMonto: { usd: totalMontoUsd, bs: totalMontoBs },
    totalPagado: { usd: totalPagadoUsd, bs: totalPagadoBs },
    totalSaldo: { usd: totalSaldoUsd, bs: totalSaldoBs },
    porcentajePagado: {
      usd: totalMontoUsd > 0 ? (totalPagadoUsd / totalMontoUsd) * 100 : 0,
      bs: totalMontoBs > 0 ? (totalPagadoBs / totalMontoBs) * 100 : 0
    },
    proximaCuota,
    estaAlDia: cuotasVencidas === 0
  };
};

/**
 * Formatear fecha de vencimiento
 * @param {string} fechaISO - Fecha en formato ISO o YYYY-MM-DD
 * @param {boolean} completo - Si incluir hora completa
 * @returns {string} Fecha formateada
 */
export const formatearFechaVencimiento = (fecha, completo = false) => {
  if (!fecha) return 'N/A';
  
  try {
    const fechaObj = new Date(fecha);
    const opciones = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    
    if (completo) {
      opciones.hour = '2-digit';
      opciones.minute = '2-digit';
    }
    
    return fechaObj.toLocaleDateString('es-ES', opciones);
  } catch (error) {
    return fecha;
  }
};

/**
 * Formatear estado de cuota a texto legible
 * @param {string} estado - Estado de la cuota
 * @returns {string} Estado formateado
 */
export const formatearEstadoCuota = (estado) => {
  if (!estado) return 'No especificado';
  
  const estados = {
    'pendiente': 'Pendiente',
    'pagada': 'Pagada',
    'vencida': 'Vencida',
    'anulada': 'Anulada'
  };
  
  return estados[estado.toLowerCase()] || estado.charAt(0).toUpperCase() + estado.slice(1);
};

/**
 * Obtener color según estado de cuota
 * @param {string} estado - Estado de la cuota
 * @returns {string} Color en formato Tailwind
 */
export const getColorPorEstadoCuota = (estado) => {
  if (!estado) return 'bg-gray-100 text-gray-800';
  
  const colores = {
    'pendiente': 'bg-yellow-100 text-yellow-800',
    'pagada': 'bg-green-100 text-green-800',
    'vencida': 'bg-red-100 text-red-800',
    'anulada': 'bg-gray-100 text-gray-800'
  };
  
  return colores[estado.toLowerCase()] || 'bg-gray-100 text-gray-800';
};

/**
 * Verificar si una cuota está vencida
 * @param {Object} cuota - Objeto cuota
 * @returns {boolean} True si está vencida
 */
export const estaVencida = (cuota) => {
  if (!cuota.fechaVencimiento) return false;
  if (cuota.estado?.toLowerCase() === 'pagada') return false;
  
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const fechaVen = new Date(cuota.fechaVencimiento);
  
  return fechaVen < hoy;
};

/**
 * Calcular días de vencimiento
 * @param {Object} cuota - Objeto cuota
 * @returns {number} Días vencidos
 */
export const calcularDiasVencidos = (cuota) => {
  if (!estaVencida(cuota)) return 0;
  
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const fechaVen = new Date(cuota.fechaVencimiento);
  
  const diffTime = hoy - fechaVen;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
};

/**
 * Calcular intereses de mora
 * @param {Object} cuota - Objeto cuota
 * @param {number} tasaInteresDiario - Tasa de interés diario (porcentaje)
 * @returns {Object} Intereses calculados
 */
export const calcularInteresMora = (cuota, tasaInteresDiario = 0.1) => {
  if (!estaVencida(cuota)) {
    return { usd: 0, bs: 0 };
  }
  
  const diasVencidos = calcularDiasVencidos(cuota);
  const saldoUsd = cuota.saldoUsd || 0;
  const saldoBs = cuota.saldoBs || 0;
  
  const interesUsd = (saldoUsd * (tasaInteresDiario / 100)) * diasVencidos;
  const interesBs = (saldoBs * (tasaInteresDiario / 100)) * diasVencidos;
  
  return {
    usd: Math.round(interesUsd * 100) / 100,
    bs: Math.round(interesBs * 100) / 100,
    diasVencidos
  };
};

// ==================== FUNCIONES DE EXPORTACIÓN ====================

/**
 * Exportar cuotas a Excel
 * @param {Array} cuotas - Lista de cuotas
 * @param {string} filename - Nombre del archivo (sin extensión)
 * @returns {Object} Resultado de la exportación
 */
export const exportarCuotasExcel = (cuotas, filename = 'cuotas_credito') => {
  try {
    if (typeof window === 'undefined') {
      return {
        success: false,
        error: 'Exportación solo disponible en el navegador',
        filename: null
      };
    }
    
    const XLSX = require('xlsx');
    const wb = XLSX.utils.book_new();
    
    const data = cuotas.map(cuota => ({
      'ID Cuota': cuota.idCreditoCuota || '',
      'ID Venta': cuota.idVenta || '',
      'Tipo Crédito': cuota.codigoTipoCredito || '',
      'N° Cuota': cuota.numeroCuota || '',
      'Vencimiento': formatearFechaVencimiento(cuota.fechaVencimiento),
      'Monto USD': cuota.montoUsd || 0,
      'Saldo USD': cuota.saldoUsd || 0,
      'Monto Bs': cuota.montoBs || 0,
      'Saldo Bs': cuota.saldoBs || 0,
      'Interés Mora USD': cuota.interesMoraUsd || 0,
      'Interés Mora Bs': cuota.interesMoraBs || 0,
      'Estado': formatearEstadoCuota(cuota.estado),
      'Fecha Pago': formatearFechaVencimiento(cuota.fechaPago, true),
      'Observaciones': cuota.observaciones || ''
    }));
    
    const ws = XLSX.utils.json_to_sheet(data);
    
    const wscols = [
      { wch: 10 },  // ID Cuota
      { wch: 10 },  // ID Venta
      { wch: 15 },  // Tipo Crédito
      { wch: 10 },  // N° Cuota
      { wch: 15 },  // Vencimiento
      { wch: 12 },  // Monto USD
      { wch: 12 },  // Saldo USD
      { wch: 12 },  // Monto Bs
      { wch: 12 },  // Saldo Bs
      { wch: 15 },  // Interés Mora USD
      { wch: 15 },  // Interés Mora Bs
      { wch: 12 },  // Estado
      { wch: 20 },  // Fecha Pago
      { wch: 40 }   // Observaciones
    ];
    ws['!cols'] = wscols;
    
    XLSX.utils.book_append_sheet(wb, ws, 'Cuotas Crédito');
    
    const fecha = new Date();
    const fechaStr = fecha.toISOString().split('T')[0];
    const nombreArchivo = `${filename}_${fechaStr}.xlsx`;
    
    XLSX.writeFile(wb, nombreArchivo);
    
    return {
      success: true,
      filename: nombreArchivo,
      message: `Archivo ${nombreArchivo} generado exitosamente`,
      count: cuotas.length
    };
    
  } catch (error) {
    console.error('❌ Error exportando a Excel:', error);
    return {
      success: false,
      error: error.message,
      filename: null
    };
  }
};

/**
 * Exportar cuotas a PDF
 * @param {Array} cuotas - Lista de cuotas
 * @param {string} titulo - Título del reporte
 * @param {string} logoBase64 - Logo en base64 (opcional)
 * @returns {Object} Resultado de la exportación
 */
export const exportarCuotasPDF = (cuotas, titulo = 'Reporte de Cuotas de Crédito', logoBase64 = null) => {
  try {
    console.log('📊 Exportando PDF de cuotas...');
    
    if (typeof window === 'undefined') {
      return {
        success: false,
        error: 'Exportación solo disponible en el navegador',
        filename: null
      };
    }
    
    if (!cuotas || cuotas.length === 0) {
      throw new Error('No hay cuotas para exportar');
    }
    
    let jsPDF;
    try {
      const jspdf = require('jspdf');
      jsPDF = jspdf.jsPDF;
      require('jspdf-autotable');
    } catch (e) {
      console.error('❌ jsPDF no está disponible:', e);
      return {
        success: false,
        error: 'La librería jsPDF no está disponible',
        filename: null
      };
    }
    
    const doc = new jsPDF('landscape');
    const fecha = new Date();
    const fechaStr = fecha.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    
    let y = 20;
    const marginLeft = 20;
    const pageWidth = doc.internal.pageSize.width;
    
    let logoAgregado = false;
    if (logoBase64) {
      try {
        doc.addImage(logoBase64, 'JPEG', marginLeft, 10, 30, 15);
        logoAgregado = true;
        y = 35;
      } catch (logoError) {
        console.warn('⚠️ Error al agregar logo:', logoError);
        y = 20;
      }
    }
    
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    const titleX = logoAgregado ? 60 : marginLeft;
    doc.text('JEAN INFORMATICO C.A.', titleX, y);
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(titulo, titleX, y + 8);
    
    y += 20;
    doc.setFontSize(10);
    doc.text(`Fecha: ${fechaStr}`, marginLeft, y);
    doc.text(`Total: ${cuotas.length} cuotas`, marginLeft + 80, y);
    
    y += 15;
    const estadisticas = obtenerEstadisticasCuotas(cuotas);
    
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text('Resumen Estadístico', marginLeft, y);
    
    y += 8;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    
    const resumen = [
      `Total Monto: $${estadisticas.totalMonto.usd.toFixed(2)} | Bs ${estadisticas.totalMonto.bs.toFixed(2)}`,
      `Total Pagado: $${estadisticas.totalPagado.usd.toFixed(2)} | Bs ${estadisticas.totalPagado.bs.toFixed(2)}`,
      `Total Saldo: $${estadisticas.totalSaldo.usd.toFixed(2)} | Bs ${estadisticas.totalSaldo.bs.toFixed(2)}`,
      `Pendientes: ${estadisticas.estados.pendientes} | Pagadas: ${estadisticas.estados.pagadas} | Vencidas: ${estadisticas.estados.vencidas}`,
      `Tasa de cumplimiento: ${estadisticas.tasaCumplimiento.toFixed(1)}%`
    ];
    
    resumen.forEach((linea, index) => {
      doc.text(`• ${linea}`, marginLeft + 5, y + (index * 5));
    });
    
    const tableData = cuotas.map(cuota => [
      cuota.idCreditoCuota || '',
      cuota.idVenta || '',
      cuota.codigoTipoCredito || '',
      cuota.numeroCuota || '',
      formatearFechaVencimiento(cuota.fechaVencimiento),
      `$${(cuota.montoUsd || 0).toFixed(2)}`,
      `$${(cuota.saldoUsd || 0).toFixed(2)}`,
      `Bs ${(cuota.montoBs || 0).toFixed(2)}`,
      `Bs ${(cuota.saldoBs || 0).toFixed(2)}`,
      formatearEstadoCuota(cuota.estado),
      formatearFechaVencimiento(cuota.fechaPago)
    ]);
    
    doc.autoTable({
      startY: y + 25,
      head: [['ID', 'Venta', 'Tipo', 'N°', 'Vencimiento', 'Monto USD', 'Saldo USD', 'Monto Bs', 'Saldo Bs', 'Estado', 'Fecha Pago']],
      body: tableData,
      theme: 'striped',
      headStyles: {
        fillColor: [79, 70, 229],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 8
      },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: 12 },
        2: { cellWidth: 15 },
        3: { cellWidth: 10 },
        4: { cellWidth: 20 },
        5: { cellWidth: 18 },
        6: { cellWidth: 18 },
        7: { cellWidth: 18 },
        8: { cellWidth: 18 },
        9: { cellWidth: 15 },
        10: { cellWidth: 20 }
      },
      styles: {
        fontSize: 7,
        cellPadding: 2,
        overflow: 'linebreak'
      },
      didDrawPage: function(data) {
        doc.setFontSize(7);
        doc.setTextColor(100, 100, 100);
        doc.text('© Jean Informatico C.A. - Sistema de Gestión de Créditos', marginLeft, 195);
        doc.text(`Página ${data.pageNumber}`, pageWidth - marginLeft, 195, null, null, 'right');
      }
    });
    
    const fechaISO = fecha.toISOString().split('T')[0];
    const nombreArchivo = `cuotas_credito_${fechaISO}.pdf`;
    doc.save(nombreArchivo);
    
    return {
      success: true,
      filename: nombreArchivo,
      message: 'PDF generado exitosamente',
      count: cuotas.length,
      withLogo: logoAgregado
    };
    
  } catch (error) {
    console.error('❌ Error exportando PDF:', error);
    return {
      success: false,
      error: error.message,
      filename: null
    };
  }
};

// ==================== EXPORT DEFAULT ====================

export default {
  // Funciones API
  obtenerCuotasCredito,
  obtenerCuotaPorId,
  obtenerCuotasPendientes,
  obtenerCuotasVencidas,
  obtenerCuotasPorEstado,
  obtenerCuotasPorVenta,
  obtenerResumenCuotasVenta,
  obtenerCuotasPorVencimiento,
  obtenerCuotaConRelaciones,
  buscarCuotasAPI,
  verificarCuotaExistente,
  crearCuotaCredito,
  crearMultiplesCuotas,
  actualizarCuotaCredito,
  pagarCuota,
  eliminarCuotaCredito,
  
  // Funciones auxiliares
  formatearFechaVencimiento,
  formatearEstadoCuota,
  getColorPorEstadoCuota,
  estaVencida,
  calcularDiasVencidos,
  calcularInteresMora,
  buscarCuotasLocal,
  filtrarCuotasPorEstadoLocal,
  filtrarCuotasPorFechaLocal,
  obtenerEstadisticasCuotas,
  ordenarCuotas,
  agruparCuotasPorVenta,
  calcularResumenVentaCuotas,
  
  // Funciones de exportación
  exportarCuotasExcel,
  exportarCuotasPDF
};